"use client";
import Image from "next/image";
import Reveal from "./Reveal"
import { useTranslations } from "next-intl";

export default function Decentralized() {
    const t = useTranslations('enterprise');
    return (
        <section className="max-w-[1440px] mx-auto py-20 px-[78px] max-xl:px-10 max-sm:px-4 flex max-lg:flex-col max-lg:gap-10 max-lg:text-center bg-gradient-to-tl from-[#ECF3FF] to-transparent">
            <div className="w-1/2 max-lg:w-full">
                <Reveal 
                    delay={0.1} 
                    duration={0.8} 
                    direction="left"
                    withBlur={true}
                    blurAmount={8}
                >
                    <h2 className="text-[48px]/[56px] max-lg:text-[32px]/[40px] max-sm:text-[24px]/[32px] max-lg:max-w-[490px] max-lg:mx-auto text-[#202020] tracking-[-1px]">{t('from-decentralized-governance-to-tokenized-equity-to-public-listing')}</h2>
                </Reveal>
                <Reveal 
                    delay={0.4} 
                    duration={0.8} 
                    direction="left"
                    withBlur={true}
                    blurAmount={8}
                >
                    <p className="text-base max-lg:text-sm text-[#646464] font-light mt-6 max-w-[521px] max-lg:mx-auto">{t('hyra-network-is-governed-by-a-decentralized-autonomous-organization-dao-legally-represented-by-the-hyra-foundation-a-non-profit-entity-registered-in-zug-switzerland')}</p>
                </Reveal>
            </div>
            <div className="w-1/2 max-lg:w-full relative">
                <Image 
                    src="/images/icons/decentralized.png" 
                    alt="Decentralized" 
                    width={600} 
                    height={400} 
                    className="z-50 mx-auto"
                />
            </div>
        </section>
    )
}